import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import EmptyAnal from "./EmptyAnal";
import { Progress } from "antd";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 22, color: "white" }} spin />
);

const AnalSenti = ({ memo, isIndex }) => {
  const [analData, setAnalData] = useState(null);
  const [load, setLoad] = useState(false);
  const handleClick = useCallback(() => {
    setLoad(true);
    const content = memo;
    axios
      .get("https://api.aiforthai.in.th/ssense", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
        },
        params: {
          text: content.slice(0, 600).replace(/%/g, "Percent"),
        },
      })
      .then((res) => {
        const data = res.data;
        console.log(data);
        setTimeout(() => {
          if (data) {
            setAnalData(data);
          }
          setLoad(false);
        }, 500);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [memo]);
  useEffect(() => {
    if (!isIndex) {
      handleClick();
    }
  }, [handleClick, isIndex]);
  return (
    <div className="bg-gray-100 w-full p-3 rounded-md mb-3">
      <p className="m-0 p-0 text-blue-400 font-bold">SENTIMENT ANALYSIS</p>
      <div className="bg-gray-100 border-2 border-blue-400 border-dotted w-full rounded-md my-3 px-3 py-4">
        {analData ? (
          <div>
            <div className="w-full flex items-center justify-around">
              <Progress
                type="dashboard"
                percent={parseInt(analData.sentiment.score)}
                trailColor="#BFDBFE"
                strokeColor={`${
                  analData.sentiment.polarity === ""
                    ? "#60A5FA"
                    : analData.sentiment.polarity === "positive"
                    ? "#34D399"
                    : "#F87171"
                }`}
                format={(percent) => {
                  return (
                    <div className="m-0 p-0 text-blue-400 flex justify-center items-center">
                      {analData.sentiment.polarity === "" ? (
                        <svg
                          className="w-20"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      ) : analData.sentiment.polarity === "positive" ? (
                        <svg
                          className="w-20 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      ) : (
                        <svg
                          fill="none"
                          stroke="currentColor"
                          className="w-20 text-red-400"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      )}
                    </div>
                  );
                }}
              />
              <div className="text-center">
                <p className="m-0 p-0 text-blue-400">
                  <span className="font-bold">Score :</span>{" "}
                  {analData.sentiment.score}
                  <br />
                  <span className="font-bold">Polarity :</span>{" "}
                  <span
                    className={`${
                      analData.sentiment.polarity === ""
                        ? "text-blue-400"
                        : analData.sentiment.polarity === "positive"
                        ? "text-green-400"
                        : "text-red-400"
                    } font-bold`}
                  >
                    {analData.sentiment.polarity === ""
                      ? "Neutral"
                      : analData.sentiment.polarity === "positive"
                      ? "Positive"
                      : "Negative"}
                  </span>
                </p>
              </div>
            </div>
            <div>
              <p className="m-0 p-0 text-blue-400 font-bold">REQUEST</p>
              <Progress
                percent={parseInt(analData.intention.request)}
                status="active"
                size="small"
                trailColor="#BFDBFE"
                strokeColor="#63b3ed"
                format={(percent) => {
                  return (
                    <p className="text-blue-400 m-0 p-0">{`${percent}%`}</p>
                  );
                }}
              />
              <p className="m-0 p-0 text-blue-400 font-bold">QUESTION</p>
              <Progress
                status="active"
                percent={parseInt(analData.intention.question)}
                size="small"
                trailColor="#BFDBFE"
                strokeColor="#63b3ed"
                format={(percent) => {
                  return (
                    <p className="text-blue-400 m-0 p-0">{`${percent}%`}</p>
                  );
                }}
              />
              <p className="m-0 p-0 text-blue-400 font-bold">ANNOUNCEMENT</p>
              <Progress
                status="active"
                percent={parseInt(analData.intention.announcement)}
                size="small"
                trailColor="#BFDBFE"
                strokeColor="#63b3ed"
                format={(percent) => {
                  return (
                    <p className="text-blue-400 m-0 p-0">{`${percent}%`}</p>
                  );
                }}
              />
            </div>
            <div>
              {/* {analData.preprocess.keyword.length > 0 ? (
                <div>
                  <p className='m-0 p-0 text-blue-400 font-bold mt-3'>
                    KEYWORD
                  </p>
                  <p className='m-0 p-0 text-blue-400'>
                    {[
                      ...new Set(analData.preprocess.keyword.slice(0, 17)),
                    ].join(", ")}
                  </p>
                </div>
              ) : null} */}
              {analData.preprocess.pos.length > 0 ? (
                <div>
                  <p className="m-0 p-0 text-blue-400 font-bold mt-3">
                    POSITIVE
                  </p>
                  <p className="m-0 p-0 text-blue-400">
                    {[...new Set(analData.preprocess.pos)].join(", ")}
                  </p>
                </div>
              ) : null}
              {analData.preprocess.neg.length > 0 ? (
                <div>
                  <p className="m-0 p-0 text-blue-400 font-bold mt-3">
                    NEGATIVE
                  </p>
                  <p className="m-0 p-0 text-blue-400">
                    {[...new Set(analData.preprocess.neg)].join(", ")}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <EmptyAnal text="PRESS ANALYZE TO START" isIndex={isIndex} />
        )}
      </div>
      <div
        className={`${
          isIndex
            ? "bg-blue-400 text-white font-bold text-center p-3 rounded-md cursor-pointer hover:bg-blue-500 shadow-sm m-0 border-b-4 border-blue-500 flex justify-center items-center"
            : "hidden"
        }`}
        onClick={() => {
          if (!load) {
            handleClick();
          }
        }}
      >
        {load ? <Spin indicator={antIcon} /> : <span>ANALYZE</span>}
      </div>
    </div>
  );
};

export default AnalSenti;
